/*
  industrialkonzept Next, part 3 (2026-09-23)
  - Lifestyle pictures between the products in collections
  - Product gallery: calm pairs that always load a sharp enough picture
  - Board: collect favourites, arrange them, share the board, add everything to the cart
  Fit check, room preview and cm/inch live in ik-tools.js, which uses the helpers shared below.
  Optional: without this script the shop works as before.
*/
(() => {
  if (window.__ikLab) return;
  window.__ikLab = true;

  const root = document.documentElement;
  const template = root.getAttribute('data-ikn-template') || '';
  const T = (k, v) => (window.ikT ? window.ikT(k, v) : k);
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // prices look exactly like the theme's (window.ikMoney, layout/theme.liquid)
  const money = { format: (units) => window.ikMoney(Math.round(units * 100)) };
  const num = new Intl.NumberFormat(root.lang || undefined, { maximumFractionDigits: 1 });
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const abs = (u) => (u && u.startsWith('//') ? location.protocol + u : u || '');
  const sized = (u, w) => {
    if (!u) return '';
    const clean = abs(u).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return clean + (clean.includes('?') ? '&' : '?') + 'width=' + w;
  };
  const store = {
    get(key, fallback) {
      try {
        const v = localStorage.getItem(key);
        return v ? JSON.parse(v) : fallback;
      } catch (e) {
        return fallback;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {
        /* private mode: simply not remembered */
      }
    },
  };
  const icon = {
    // the board symbol: a push pin, which everybody links with pinning something up (the heart was
    // dropped: it promised a wish list). Outline while not pinned, filled once the product is on the board.
    pin: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 17v5"/><path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 16.5 16.5 3 21 7.5 7.5 21z"/><path d="M7 12.5l1.8 1.8M9.8 9.7l2.6 2.6M12.6 6.9l1.8 1.8"/></svg>',
    room: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 20V9l9-5 9 5v11"/><path d="M8 20v-5.5h8V20"/><path d="M3 20h18"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
  };

  const fetchProduct = (h) =>
    fetch(base + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);

  const openCartDrawer = async () => {
    // the theme redraws the drawer lines, footer and count from these sections
    try {
      const sections = await (await fetch(base + '?sections=cart-items,cart-footer,cart-item-count,cart-live-region')).json();
      window.dispatchEvent(new CustomEvent('baseline:cart:update', { detail: { response: { sections } } }));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
    try {
      if (window.Alpine && window.Alpine.store && window.Alpine.store('modals')) window.Alpine.store('modals').open('cart');
    } catch (e) {
      /* the cart icon still shows the new count */
    }
  };

  /* ---------- Sheets (dialogs) ---------- */
  const openSheet = (cls, html) => {
    const d = document.createElement('dialog');
    d.className = 'ikl-sheet ' + cls;
    d.innerHTML = html;
    document.body.appendChild(d);
    root.classList.add('ikl-lock');
    // tidy up at once when our code closes the sheet, and on the browser's own close (Esc)
    const finish = () => {
      if (!d.isConnected) return;
      d.remove();
      // another sheet may have opened meanwhile (board after "Save to my board"): keep the page locked then
      if (!document.querySelector('dialog.ikl-sheet[open]')) root.classList.remove('ikl-lock');
    };
    // iOS before 15.4 has no <dialog>: the sheet then shows as a plain fixed layer (ik-lab.css)
    const modal = typeof d.showModal === 'function';
    const nativeClose = modal ? d.close.bind(d) : () => d.removeAttribute('open');
    d.close = (value) => {
      nativeClose(value);
      finish();
    };
    d.addEventListener('close', finish);
    d.addEventListener('click', (e) => {
      if (e.target === d || e.target.closest('[data-ikl-close]')) d.close();
    });
    // Esc closes every sheet ourselves: Chrome ignores it for a dialog that opened after the picture was
    // drawn (no "fresh" click any more), which left the story window open
    d.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      d.close();
    });
    if (modal) d.showModal();
    else {
      d.classList.add('is-fallback');
      d.setAttribute('open', '');
    }
    return d;
  };
  const sheetHead = (label, title, sub) =>
    '<div class="ikl-sheet__head"><div><span class="ikh-label">' + esc(label) + '</span>' +
    '<h2 class="ikl-sheet__title">' + esc(title) + '</h2>' +
    (sub ? '<p class="ikl-sheet__sub" data-ikl-sub>' + sub + '</p>' : '') +
    '</div><button type="button" class="ikl-x" data-ikl-close aria-label="' + esc(T('lab.close')) + '">' + icon.close + '</button></div>';

  // "Share as story" on computers (ik-product-story.js, ik-article.js): no download straight away, but a
  // quiet window with the finished picture and two buttons, "Save picture" and "Copy link"
  window.ikStoryPreview = (file, link, title, sub) => {
    const src = URL.createObjectURL(file);
    // wide: the picture on the left; on the right the name on top and the two buttons at the bottom
    const d = openSheet(
      'ikp-sheet',
      '<div class="ikl-sheet__head ikp-sheet__head"><span class="ikh-label">' + esc(T('story.share')) + '</span>' +
      '<button type="button" class="ikl-x" data-ikl-close aria-label="' + esc(T('lab.close')) + '">' + icon.close + '</button></div>' +
      '<div class="ikp-sheet__body"><img class="ikp-sheet__pic" src="' + esc(src) + '" width="1080" height="1920" alt="">' +
      '<div class="ikp-sheet__side"><div><h2 class="ikl-sheet__title">' + esc(title) + '</h2>' +
      (sub ? '<p class="ikl-sheet__sub">' + esc(sub) + '</p>' : '') + '</div>' +
      '<div class="ikp-sheet__actions">' +
      '<button type="button" class="ikl-btn ikl-btn--dark" data-ikp-save>' + esc(T('story.save_picture')) + '</button>' +
      '<button type="button" class="ikl-btn ikl-btn--ghost" data-ikp-copy>' + esc(T('story.copy_link')) + '</button>' +
      '<input class="ikp-sheet__link" data-ikp-link type="text" readonly value="' + esc(link) + '" aria-label="' +
      esc(T('story.copy_link')) + '" hidden></div></div></div>'
    );
    d.addEventListener('close', () => URL.revokeObjectURL(src));
    const flash = (btn, text) => {
      const was = btn.textContent;
      btn.textContent = text;
      window.setTimeout(() => (btn.textContent = was), 2000);
    };
    d.addEventListener('click', async (e) => {
      const save = e.target.closest('[data-ikp-save]');
      if (save) {
        const a = document.createElement('a');
        a.href = src;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        flash(save, T('story.saved'));
      }
      const copyBtn = e.target.closest('[data-ikp-copy]');
      if (copyBtn) {
        let ok = navigator.clipboard ? await navigator.clipboard.writeText(link).then(() => true, () => false) : false;
        const field = d.querySelector('[data-ikp-link]');
        if (!ok) {
          // older browsers or a blocked clipboard: the selected field under the buttons
          field.select();
          try {
            ok = document.execCommand('copy');
          } catch (x) {}
        }
        if (ok) flash(copyBtn, T('story.link_copied'));
        else {
          field.hidden = false;
          field.select();
        }
      }
    });
    return d;
  };

  /* =====================================================================
     1. Lifestyle pictures between the products (collections)
     One picture after the first row, then one every twelve products, alternating sides.
     Runs again when filters, sorting or infinite scroll change the grid.
     ===================================================================== */
  const moodData = document.querySelector('[data-ikn-moods]');
  if (moodData && template === 'collection') {
    let moods = [];
    try {
      moods = JSON.parse(moodData.textContent) || [];
    } catch (e) {
      moods = [];
    }
    const tile = (m, k) => {
      const li = document.createElement('li');
      li.className = 'ikn-mood' + (k % 2 ? ' is-right' : '');
      li.setAttribute('data-ikn-mood', String(k));
      li.innerHTML =
        '<a class="ikn-mood__link" href="' + esc(m.url) + '">' +
        '<img src="' + esc(abs(m.img)) + '" alt="' + esc(m.title) + '" loading="lazy">' +
        '<span class="ikn-mood__cap"><span><span class="ikh-label">' + esc(m.vendor) + '</span>' +
        '<span class="ikn-mood__title">' + esc(m.title) + '</span></span>' +
        '<span class="ikn-mood__cta">' + esc(T('lab.discover')) + '</span></span></a>';
      return li;
    };
    const place = () => {
      const list = document.querySelector('ul.collection-list');
      if (!list || !moods.length) return;
      const products = [...list.children].filter((li) => !li.classList.contains('ikn-mood'));
      for (let k = 0; k < moods.length; k += 1) {
        const at = 4 + k * 12;
        // Only when there are products on both sides of the picture
        if (products.length < at + 4) break;
        if (list.querySelector('[data-ikn-mood="' + k + '"]')) continue;
        list.insertBefore(tile(moods[k], k), products[at]);
      }
    };
    place();
    let moodTimer = 0;
    new MutationObserver((records) => {
      if (records.every((r) => [...r.addedNodes].every((n) => n.nodeType !== 1 || n.classList.contains('ikn-mood')))) return;
      window.clearTimeout(moodTimer);
      moodTimer = window.setTimeout(place, 150);
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }

  /* =====================================================================
     2. Product gallery: tell the browser the real picture width
     The theme guesses a quarter of the screen, which loads pictures that are too small.
     ===================================================================== */
  const gallery = document.querySelector('.product-media-container .splide__list');
  if (gallery) {
    const fit = (img) => {
      const w = Math.ceil(img.getBoundingClientRect().width);
      if (w > 40) img.sizes = w + 'px';
    };
    const imgs = gallery.querySelectorAll('img[srcset]');
    imgs.forEach(fit);
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver((entries) => entries.forEach((e) => fit(e.target)));
      imgs.forEach((img) => ro.observe(img));
    }
  }

  /* =====================================================================
     3. Board: favourites you can arrange, share and buy in one go
     ===================================================================== */
  const BOARD_KEY = 'ikn-board';
  const getBoard = () => store.get(BOARD_KEY, []).filter((i) => i && i.h);
  const saveBoard = (items) => {
    store.set(BOARD_KEY, items.slice(0, 40));
    document.dispatchEvent(new CustomEvent('ikl:board'));
  };
  // A pin is a product (h) or one variant of it (k = "handle~variant id": pinned on the product page with
  // that variant chosen, so the board shows its picture and price and the cart gets exactly that one).
  // Pins from product tiles and pins saved before this only have h. Handles never contain "~".
  const keyOf = (i) => i.k || i.h;
  const splitKey = (key) => {
    const [h, vid] = String(key).split('~');
    return { h, vid: parseInt(vid, 10) || 0 };
  };
  // a variant key asks for that variant; a bare handle (product tiles) for any pin of the product
  const onBoard = (key) => getBoard().some((i) => (String(key).includes('~') ? keyOf(i) === key : i.h === key));
  // the variant chosen on the product page right now (the theme keeps it in the form's hidden id field)
  const currentVid = () => {
    const f = document.querySelector('#MainContent form[action*="/cart/add"] [name="id"]');
    return (f && parseInt(f.value, 10)) || parseInt(new URL(location.href).searchParams.get('variant'), 10) || 0;
  };
  const pinKey = (h) => {
    const vid = currentVid();
    return vid ? h + '~' + vid : h;
  };
  const variantImg = (v, p) => (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
  const variantName = (v, p) => (v && p.variants && p.variants.length > 1 && v.title && v.title !== 'Default Title' ? v.title : '');
  // A loose grid with a little play, so pieces never pile up on each other
  const spot = (n) => {
    const col = n % 5;
    const row = Math.floor(n / 5) % 3;
    return {
      x: 2 + col * 18.5 + (Math.random() * 4 - 2),
      y: 3 + row * 31 + (Math.random() * 4 - 2),
      r: Math.round((Math.random() * 6 - 3) * 10) / 10,
    };
  };
  // Phones: two loose columns; mx / my count in % of the board's width, so the paper can grow downwards
  // (ik-lab.css, ".is-phone"). Without saved values a pin gets its place from its position in the list.
  const PHONE_PIN = 36; // pin width on phones, % of the board's width (ik-lab.css: 36cqw)
  const phoneSpot = (n, jitter) => ({
    mx: 6 + (n % 2) * 52 + (jitter ? Math.random() * 4 - 2 : 0),
    my: 5 + Math.floor(n / 2) * 58 + (n % 2 ? 9 : 0) + (jitter ? Math.random() * 6 - 3 : 0),
  });
  const currency = () => (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
  const itemFrom = (p, n, vid) => {
    const chosen = vid ? (p.variants || []).find((v) => v.id === vid) : null;
    const variant = chosen || (p.variants || []).find((v) => v.available) || (p.variants || [])[0] || {};
    return {
      h: p.handle,
      ...(chosen ? { k: p.handle + '~' + chosen.id, vt: variantName(chosen, p) } : {}),
      t: p.title,
      v: p.vendor,
      img: chosen ? variantImg(chosen, p) : p.featured_image || '',
      p: variant.price != null ? variant.price : p.price,
      vid: variant.id,
      ok: chosen ? !!chosen.available : !!p.available,
      cur: currency(),
      ...spot(n || 0),
    };
  };
  // Prices, stock and the currency change after a piece was pinned. Whenever the board opens, every pin is
  // read again from the shop (in the visitor's current currency): price, availability and a variant that
  // can be bought (the pinned one while available, else the first available; a pinned variant stays that
  // variant and shows as sold out when it is). Place, colour and order stay
  // as the visitor left them. A pin that cannot be read (offline, product gone) keeps its last values.
  // Resolves true when something changed.
  let refreshing = null;
  const refreshBoard = () => {
    if (refreshing) return refreshing;
    const before = getBoard();
    if (!before.length) return Promise.resolve(false);
    const handles = [...new Set(before.map((i) => i.h))];
    refreshing = Promise.all(handles.map(fetchProduct)).then((fresh) => {
      refreshing = null;
      const byHandle = {};
      handles.forEach((h, n) => (byHandle[h] = fresh[n]));
      let changed = false;
      // the board may have changed while the shop answered: update what is on it now
      const next = getBoard().map((i) => {
        const p = byHandle[i.h];
        if (!p) return i;
        const vs = p.variants || [];
        const pinned = i.k ? vs.find((x) => x.id === i.vid) : null;
        if (i.k && !pinned) return i; // the variant is gone: keep the pin as it was
        const v = pinned || vs.find((x) => x.id === i.vid && x.available) || vs.find((x) => x.available) || vs.find((x) => x.id === i.vid) || vs[0] || {};
        const upd = pinned
          ? { ...i, t: p.title, v: p.vendor, vt: variantName(pinned, p), img: variantImg(pinned, p) || i.img, p: pinned.price, ok: !!pinned.available, cur: currency() }
          : { ...i, t: p.title, v: p.vendor, img: p.featured_image || i.img, p: v.price != null ? v.price : p.price, vid: v.id || i.vid, ok: !!p.available, cur: currency() };
        if (upd.p !== i.p || upd.ok !== i.ok || upd.vid !== i.vid || upd.cur !== i.cur || upd.t !== i.t || upd.img !== i.img || upd.vt !== i.vt) changed = true;
        return upd;
      });
      if (changed) saveBoard(next);
      return changed;
    });
    return refreshing;
  };
  // Every pin gets a colour of a classic push pin set (red, yellow, blue, green; ik-lab.css .is-c0 to
  // .is-c3): the one used least so far, never the same as the pin added just before.
  const PIN_COLOURS = 4;
  const nextColour = (list) => {
    const used = Array(PIN_COLOURS).fill(0);
    list.forEach((i) => i.c != null && used[i.c % PIN_COLOURS]++);
    const last = list.length ? list[list.length - 1].c : -1;
    let best = -1;
    for (let c = 0; c < PIN_COLOURS; c++) if (c !== last && (best < 0 || used[c] < used[best])) best = c;
    return best;
  };
  // pins saved before the colours existed get theirs in list order
  const withColours = (list) => {
    if (list.every((i) => i.c != null)) return list;
    const out = [];
    list.forEach((i) => out.push(i.c != null ? i : { ...i, c: nextColour(out) }));
    return out;
  };
  const addToBoard = async (key) => {
    if (onBoard(key)) return;
    const { h, vid } = splitKey(key);
    const p = await fetchProduct(h);
    if (!p) return syncHearts(); // not saved: the symbol empties again
    const item = itemFrom(p, 0, vid);
    // a variant pinned on the product page takes the place of a pin of the same product from a tile
    // (that one had no variant chosen)
    const list = withColours(getBoard().filter((i) => keyOf(i) !== keyOf(item) && !(vid && i.h === h && !i.k)));
    saveBoard([...list, { ...item, ...spot(list.length), c: nextColour(list) }]);
  };
  // a variant key takes off that variant; a bare handle (product tiles) every pin of the product
  const removeFromBoard = (key) =>
    saveBoard(getBoard().filter((i) => (String(key).includes('~') ? keyOf(i) !== key : i.h !== key)));

  const addAllToCart = async (items, btn) => {
    const list = items.filter((i) => i.vid && i.ok !== false);
    if (!list.length) return;
    if (btn) btn.disabled = true;
    const post = (arr) =>
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: arr.map((i) => ({ id: i.vid, quantity: 1 })) }),
      });
    let res = await post(list).catch(() => null);
    // One sold out piece would stop the whole request: then add them one by one
    if (!res || !res.ok) for (const i of list) await post([i]).catch(() => null);
    if (btn) btn.disabled = false;
    const open = document.querySelector('dialog.ikl-board[open]');
    if (open) open.close();
    openCartDrawer();
  };

  // Heart buttons on product tiles (theme grids, homepage rails, "more from" rails)
  const handleOf = (href) => {
    const m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  };
  const heartHtml = (h) =>
    '<button type="button" class="ikl-heart" data-ikl-heart="' + esc(h) + '" aria-pressed="' + onBoard(h) + '" aria-label="' +
    esc(T('lab.save_to_board')) + '">' + icon.pin + '</button>';
  const decorate = () => {
    document.querySelectorAll('li > data-island.relative.flex.h-full.flex-col').forEach((tile) => {
      const link = tile.querySelector('a[href*="/products/"]');
      const holder = link && link.parentElement;
      if (!holder || holder.querySelector(':scope > .ikl-heart')) return;
      const h = handleOf(link.getAttribute('href'));
      if (h) holder.insertAdjacentHTML('beforeend', heartHtml(h));
    });
    document.querySelectorAll('a.ikh-card').forEach((card) => {
      const media = card.querySelector('.ikh-card__media');
      if (!media || media.querySelector('.ikl-heart')) return;
      const h = handleOf(card.getAttribute('href'));
      if (h) media.insertAdjacentHTML('beforeend', heartHtml(h));
    });
  };
  // the product page button follows the chosen variant (data-ikl-variant, assets/ik-tools.js)
  const heartKey = (b) => (b.hasAttribute('data-ikl-variant') ? pinKey(b.getAttribute('data-ikl-heart')) : b.getAttribute('data-ikl-heart'));
  const syncHearts = () => {
    document.querySelectorAll('[data-ikl-heart]').forEach((b) => {
      const on = onBoard(heartKey(b));
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? T('lab.remove_from_board') : T('lab.save_to_board'));
      const text = b.querySelector('[data-ikl-heart-text]');
      if (text) text.textContent = on ? T('lab.on_your_board') : T('lab.save_to_board');
    });
  };
  decorate();
  let decoTimer = 0;
  new MutationObserver((records) => {
    if (records.every((r) => [...r.addedNodes].every((n) => n.nodeType !== 1 || (n.classList && n.classList.contains('ikl-heart'))))) return;
    window.clearTimeout(decoTimer);
    decoTimer = window.setTimeout(decorate, 250);
  }).observe(document.body, { childList: true, subtree: true });

  // Capture phase: the tiles have a full size link on top, and some containers stop clicks
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('[data-ikl-heart]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const key = heartKey(btn);
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
      if (onBoard(key)) {
        removeFromBoard(key);
      } else {
        btn.setAttribute('aria-pressed', 'true');
        addToBoard(key);
      }
    },
    true
  );
  // another variant chosen: the product page button shows whether that one is on the board
  const resync = () => window.setTimeout(syncHearts, 80);
  document.addEventListener('change', resync);
  document.addEventListener('click', (e) => e.target.closest('[role="option"]') && resync());

  // Floating board button
  const fab = document.createElement('button');
  fab.type = 'button';
  fab.className = 'ikl-fab';
  fab.hidden = true;
  document.body.appendChild(fab);
  // The board sits in the header next to the cart (phones and large screens alike), with the same
  // small black count as the cart; the floating button stays only as a fallback for a header without
  // a cart (ik-lab.css, html.ikl-has-hpin)
  const headPins = [];
  document.querySelectorAll('nav a[data-cart-drawer-toggle]').forEach((cart) => {
    if (!cart.parentElement) return;
    // the header renders the pin itself, already shown on the first paint when the board has pieces
    // (sections/header.liquid, 2026-10-14); before, it was added here after loading and the search bar
    // and icons slid to the left
    let pin = cart.parentElement.previousElementSibling;
    if (pin && pin.tagName === 'SCRIPT') pin = pin.previousElementSibling;
    if (!pin || !pin.classList.contains('ikl-hpin')) {
      pin = document.createElement('button');
      pin.type = 'button';
      pin.className = 'ikl-hpin';
      pin.hidden = true;
      cart.parentElement.before(pin);
    }
    pin.addEventListener('click', () => openBoard());
    headPins.push(pin);
  });
  if (headPins.length) root.classList.add('ikl-has-hpin');

  // The cart gets the same count instead of the theme's coloured dot. The number comes from the
  // theme's cart store; its screen-reader text ("2 items") changes with every update, so that is watched.
  document.querySelectorAll('nav a[data-cart-drawer-toggle]').forEach((cart) => {
    const box = cart.querySelector('.relative') || cart;
    const sr = cart.querySelector('.sr-only');
    const badge = document.createElement('span');
    badge.className = 'ikl-hpin__n ikl-cartn';
    badge.setAttribute('aria-hidden', 'true');
    box.appendChild(badge);
    const update = () => {
      let n = null;
      try {
        n = window.Alpine.store('cartCount').count;
      } catch (e) {}
      if (typeof n !== 'number') n = parseInt((sr && sr.textContent) || '', 10) || 0;
      if (badge.textContent !== String(n)) badge.textContent = n;
      badge.hidden = !n;
    };
    update();
    if (sr) new MutationObserver(update).observe(sr, { childList: true, characterData: true, subtree: true });
    document.addEventListener('alpine:initialized', update);
    window.setTimeout(update, 1500);
  });
  const renderFab = () => {
    const items = getBoard();
    fab.hidden = !items.length;
    headPins.forEach((pin) => {
      pin.hidden = !items.length;
      pin.innerHTML = icon.pin + '<span class="ikl-hpin__n">' + items.length + '</span>';
      pin.setAttribute('aria-label', T('lab.open_board', { n: items.length }));
    });
    fab.innerHTML =
      '<span class="ikl-fab__stack" aria-hidden="true">' +
      items.slice(0, 3).map((i) => '<img src="' + esc(sized(i.img, 120)) + '" alt="">').join('') +
      '</span><span>' + esc(T('lab.your_board')) + '</span><span class="ikl-fab__n">' + icon.pin + items.length + '</span>';
    fab.setAttribute('aria-label', T('lab.open_board', { n: items.length }));
  };
  renderFab();
  fab.addEventListener('click', () => openBoard());
  document.addEventListener('ikl:board', () => {
    renderFab();
    syncHearts();
    [fab, ...headPins].forEach((b) => {
      b.classList.remove('is-bump');
      void b.offsetWidth;
      b.classList.add('is-bump');
    });
  });
  window.addEventListener('storage', (e) => {
    if (e.key === BOARD_KEY) {
      renderFab();
      syncHearts();
    }
  });

  // The board itself: a free collage on large screens, a tidy grid on phones
  const openBoard = (shared) => {
    const own = !shared;
    const items = shared || getBoard();
    const total = (list) => list.reduce((s, i) => s + (i.ok !== false && i.p ? i.p : 0), 0);
    const sub = (list) =>
      T(list.length === 1 ? 'lab.object_one' : 'lab.object_other', { n: list.length }) + ' · ' + money.format(total(list) / 100);
    const d = openSheet(
      'ikl-board',
      sheetHead(own ? T('lab.your_board') : T('lab.shared_board'),
        own ? T('lab.put_room_together') : T('lab.shared_with_you'),
        sub(items)) +
      // phones: a quiet one-line hint how to move a pin, until the first pin has been moved
      (own
        ? '<p class="ikl-board__hint" data-ikl-hint hidden><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="2.5"/><circle cx="12" cy="12" r="6.5"/></svg><span>' + esc(T('lab.hold_hint')) + '</span></p>'
        : '') +
      '<div class="ikl-board__canvas" data-ikl-canvas></div>' +
      // phones: while a pin is held, a bin shows at the bottom; drop the pin on it to take it off
      (own
        ? '<div class="ikl-trash" data-ikl-trash aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 7h16M9.5 7V4.5h5V7M6.5 7l1 13h9l1-13M10 11v5.5M14 11v5.5"/></svg><span>' + esc(T('lab.remove')) + '</span></div>'
        : '') +
      '<div class="ikl-board__foot">' +
      // honest about where the board lives: in this browser only, nothing is stored with us
      (own
        ? '<p class="ikl-board__note"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="1.5"/><path d="M8.5 10.5V7.5a3.5 3.5 0 0 1 7 0v3"/></svg><span>' + esc(T('lab.local_note')) + '</span></p>'
        : '') +
      (own
        ? '<div class="ikl-board__tools"><button type="button" class="ikl-btn ikl-btn--ghost" data-ikl-share>' + esc(T('lab.share_board')) + '</button>' +
          '<button type="button" class="ikl-btn ikl-btn--ghost" data-ikl-shuffle>' + esc(T('lab.shuffle')) + '</button>' +
          '<button type="button" class="ikl-btn ikl-btn--ghost" data-ikl-clear>' + esc(T('lab.clear')) + '</button></div>'
        : '<div class="ikl-board__tools"><button type="button" class="ikl-btn ikl-btn--ghost" data-ikl-adopt>' + esc(T('lab.save_to_my_board')) + '</button></div>') +
      '<button type="button" class="ikl-btn ikl-btn--dark" data-ikl-buyall>' + esc(T('lab.add_all_to_cart')) + '</button>' +
      '</div>'
    );
    const canvas = d.querySelector('[data-ikl-canvas]');
    const free = () => window.matchMedia('(min-width: 900px)').matches;
    const HINT_KEY = 'ikn-board-hint-done';
    const hint = d.querySelector('[data-ikl-hint]');
    if (hint && !free() && items.length && !store.get(HINT_KEY)) hint.hidden = false;
    const hintDone = () => {
      if (!hint || hint.hidden) return;
      store.set(HINT_KEY, 1);
      hint.classList.add('is-gone');
      window.setTimeout(() => (hint.hidden = true), 400);
    };
    // phones: the paper is as tall as the lowest pin plus room for it
    const fitHeight = () => {
      // one hundredth of the board's width, for browsers without container units (iOS before 16)
      canvas.style.setProperty('--u', canvas.clientWidth / 100 + 'px');
      const lows = [...canvas.querySelectorAll('[data-ikl-pin]')].map((p) => parseFloat(p.style.getPropertyValue('--my')) || 0);
      canvas.style.setProperty('--h', Math.max(100, Math.max(0, ...lows) + PHONE_PIN * 1.6 + 6).toFixed(1));
    };
    // A pin stays where it is let go, only kept inside the board.
    const snapPin = (pin) => {
      const cw = canvas.clientWidth;
      const ch = canvas.clientHeight;
      const unit = cw / 100;
      // phones: size and place follow from the board's width (--mx / --my, PHONE_PIN wide); large
      // screens: layout sizes (offset*), not the on-screen box, since a pin that was just let go is still scaled
      const phone = !free();
      const w = phone ? PHONE_PIN * unit : pin.offsetWidth;
      const h = pin.offsetHeight;
      let left = phone ? (parseFloat(pin.style.getPropertyValue('--mx')) || 0) * unit : pin.offsetLeft;
      let top = phone ? (parseFloat(pin.style.getPropertyValue('--my')) || 0) * unit : pin.offsetTop;
      left = Math.max(4, Math.min(cw - w - 4, left));
      top = Math.max(10, phone ? top : Math.min(ch - h - 4, top));
      if (free()) {
        pin.style.setProperty('--x', ((left / cw) * 100).toFixed(3) + '%');
        pin.style.setProperty('--y', ((top / ch) * 100).toFixed(3) + '%');
      } else {
        pin.style.setProperty('--mx', (left / unit).toFixed(3));
        pin.style.setProperty('--my', (top / unit).toFixed(3));
      }
    };
    // Large screens: a board is laid out once, loosely over the whole sheet, and then stays as it is: pins
    // keep the place they were given or dragged to (saved with "pl"). Pins that never had a place (a new
    // board, a newly pinned product, boards saved before this) get one when the board opens; "Shuffle"
    // lays out everything afresh. Shared boards are laid out on every visit.
    let scatterNext = true;
    let scatterAll = false;
    const scatter = () => {
      const pins = [...canvas.querySelectorAll('[data-ikl-pin]')];
      const cw = canvas.clientWidth;
      const ch = canvas.clientHeight;
      const pad = 16;
      // the sheet is still opening while the board has no real height yet: wait for it (ResizeObserver below)
      if (!pins.length || !cw || ch < pins[0].offsetHeight + 2 * pad) return false;
      const saved = {};
      if (own) getBoard().forEach((i) => (saved[keyOf(i)] = i.pl));
      const todo = scatterAll || !own ? pins : pins.filter((p) => !saved[p.getAttribute('data-ikl-pin')]);
      scatterAll = false;
      if (!todo.length) return true;
      const w = pins[0].offsetWidth;
      const h = pins[0].offsetHeight;
      const spanX = Math.max(1, cw - w - 2 * pad);
      const spanY = Math.max(1, ch - h - 2 * pad);
      // the board's title block (bottom right) stays free
      const plate = canvas.querySelector('.ikl-plate');
      const pl = plate ? { x: plate.offsetLeft - 12, y: plate.offsetTop - 12 } : null;
      const put = (pin, left, top) => {
        if (pl && left + w > pl.x && top + h > pl.y) top = Math.max(pad, pl.y - h);
        pin.style.setProperty('--x', ((left / cw) * 100).toFixed(3) + '%');
        pin.style.setProperty('--y', ((top / ch) * 100).toFixed(3) + '%');
      };
      if (todo.length === pins.length) {
        // everything: one cell per pin in a grid shaped like the sheet, cells in random order, each pin
        // somewhere inside its cell (up to a fifth of a step off), so no two sit on one line
        const cols = Math.max(1, Math.min(pins.length, Math.round(Math.sqrt((pins.length * (spanX + w)) / (spanY + h)))));
        const rows = Math.ceil(pins.length / cols);
        const cells = [...Array(cols * rows).keys()].sort(() => Math.random() - 0.5);
        pins.forEach((pin, n) => {
          const cell = cells[n];
          const cx = cols > 1 ? (cell % cols) / (cols - 1) : Math.random();
          const cy = rows > 1 ? Math.floor(cell / cols) / (rows - 1) : Math.random();
          put(pin,
            pad + spanX * Math.min(1, Math.max(0, cx + (Math.random() - 0.5) * (cols > 1 ? 0.4 / (cols - 1) : 0))),
            pad + spanY * Math.min(1, Math.max(0, cy + (Math.random() - 0.5) * (rows > 1 ? 0.4 / (rows - 1) : 0))));
        });
      } else {
        // only the new ones: the freest of a few random spots, the others stay where they are
        const boxes = pins.filter((p) => !todo.includes(p)).map((p) => [p.offsetLeft, p.offsetTop]);
        todo.forEach((pin) => {
          let best = null;
          for (let k = 0; k < 40; k++) {
            const x = pad + Math.random() * spanX;
            const y = pad + Math.random() * spanY;
            const hit = boxes.reduce((sum, [bx, by]) => sum + Math.max(0, Math.min(x + w, bx + w) - Math.max(x, bx)) * Math.max(0, Math.min(y + h, by + h) - Math.max(y, by)), 0);
            if (!best || hit < best[2]) best = [x, y, hit];
          }
          put(pin, best[0], best[1]);
          boxes.push([best[0], best[1]]);
        });
      }
      if (own) {
        const at = {};
        pins.forEach((p) => (at[p.getAttribute('data-ikl-pin')] = { x: parseFloat(p.style.getPropertyValue('--x')), y: parseFloat(p.style.getPropertyValue('--y')), pl: 1 }));
        store.set(BOARD_KEY, getBoard().map((i) => (at[keyOf(i)] ? { ...i, ...at[keyOf(i)] } : i)));
      }
      return true;
    };
    // the short press of a pin being pushed in
    const clack = (pin) => {
      pin.classList.remove('is-snap');
      void pin.offsetWidth;
      pin.classList.add('is-snap');
    };
    // the board's number: a fingerprint of the products on it (same products, same number; also on a
    // shared link), not an order or customer number
    const boardNo = (list) => {
      let n = 7;
      list.map(keyOf).sort().join(',').split('').forEach((c) => (n = (n * 31 + c.charCodeAt(0)) % 65536));
      return n.toString(16).toUpperCase().padStart(4, '0');
    };

    const draw = () => {
      let list = own ? getBoard() : items;
      if (list.some((i) => i.c == null)) {
        list = withColours(list);
        if (own) store.set(BOARD_KEY, list);
      }
      const subEl = d.querySelector('[data-ikl-sub]');
      if (subEl) subEl.textContent = sub(list);
      // a pin board everywhere: dragged freely on large screens, held and moved with a finger on phones
      canvas.classList.add('is-free');
      canvas.classList.toggle('is-phone', !free());
      if (!list.length) {
        canvas.innerHTML =
          '<div class="ikl-board__empty"><span class="ikl-board__empty-heart">' + icon.pin + '</span><p>' +
          esc(T('lab.board_empty')) +
          '</p></div>';
        return;
      }
      canvas.innerHTML = list
        .map(
          (i, n) =>
            '<figure class="ikl-pin is-c' + ((i.c || 0) % PIN_COLOURS) + (i.ok === false ? ' is-out' : '') + '" data-ikl-pin="' + esc(keyOf(i)) + '" style="--x:' + (i.x || 10) + '%;--y:' + (i.y || 10) + '%;--r:' + (i.r || 0) + 'deg;--z:' + (list.length - n) +
            ';--mx:' + (i.mx != null ? i.mx : phoneSpot(n).mx) + ';--my:' + (i.my != null ? i.my : phoneSpot(n).my) + '">' +
            '<a class="ikl-pin__img" href="' + esc(base + 'products/' + i.h + (i.k ? '?variant=' + i.vid : '')) + '" draggable="false"><img src="' + esc(sized(i.img, 480)) + '" alt="" draggable="false"></a>' +
            '<figcaption><span class="ikl-pin__vendor">' + esc(i.v) + '</span><span class="ikl-pin__title">' + esc(i.t) + '</span>' +
            (i.vt ? '<span class="ikl-pin__variant">' + esc(i.vt) + '</span>' : '') +
            '<span class="ikl-pin__price">' + (i.ok === false ? esc(T('lab.sold_out')) : money.format((i.p || 0) / 100)) + '</span></figcaption>' +
            (own ? '<button type="button" class="ikl-pin__x" data-ikl-remove="' + esc(keyOf(i)) + '" aria-label="' + esc(T('lab.remove')) + '">' + icon.close + '</button>' : '') +
            '</figure>'
        )
        .join('') +
        // the title block of a technical drawing: board number, contents, date
        '<div class="ikl-plate" aria-hidden="true"><span class="ikl-plate__k">IK—Board</span><span>Nr. ' + boardNo(list) + '</span>' +
        '<span class="ikl-plate__wide">' + esc(sub(list)) + '</span>' +
        '<span class="ikl-plate__wide">' + esc(new Intl.DateTimeFormat(root.lang || undefined, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date())) + '</span></div>';
      if (free() && scatterNext && scatter()) scatterNext = false;
      snapAll();
      fitHeight();
    };
    // large screens: not while the sheet is still opening (the board is a few pixels tall for a moment,
    // which would push every pin to the same height); the ResizeObserver below runs it once it has its size
    const settled = () => {
      const pin = canvas.querySelector('[data-ikl-pin]');
      return !free() || !pin || canvas.clientHeight >= pin.offsetHeight + 32;
    };
    const snapAll = () => settled() && canvas.querySelectorAll('[data-ikl-pin]').forEach(snapPin);
    // again whenever the board changes its size (the sheet settles after opening; on phones the pins
    // are sized by the board's width)
    let lastSize = '';
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => {
        const laid = free() && scatterNext && scatter();
        if (laid) scatterNext = false;
        const size = canvas.clientWidth + 'x' + canvas.clientHeight;
        if (!laid && size === lastSize) return;
        lastSize = size;
        snapAll();
        fitHeight();
      }).observe(canvas);
    }
    draw();
    // prices and stock of the pins as they are now (own board; a shared link is read fresh anyway)
    if (own) refreshBoard().then((changed) => changed && d.open && draw());

    // Drag pins around (own board only): with the mouse on large screens, hold and move on phones.
    // Positions are remembered, separately for both.
    if (own) {
      let drag = null;
      canvas.addEventListener('pointerdown', (e) => {
        const pin = e.target.closest('[data-ikl-pin]');
        if (!pin || !free() || e.target.closest('[data-ikl-remove]')) return;
        const rect = canvas.getBoundingClientRect();
        const pr = pin.getBoundingClientRect();
        drag = { pin, rect, dx: e.clientX - pr.left, dy: e.clientY - pr.top, moved: false, sx: e.clientX, sy: e.clientY };
        pin.setPointerCapture(e.pointerId);
        pin.classList.add('is-drag');
        canvas.querySelectorAll('[data-ikl-pin]').forEach((p) => p.style.setProperty('--z', p === pin ? 999 : Math.min(998, +p.style.getPropertyValue('--z') || 1)));
      });
      canvas.addEventListener('pointermove', (e) => {
        if (!drag) return;
        if (Math.abs(e.clientX - drag.sx) + Math.abs(e.clientY - drag.sy) > 4) drag.moved = true;
        const x = ((e.clientX - drag.rect.left - drag.dx) / drag.rect.width) * 100;
        const y = ((e.clientY - drag.rect.top - drag.dy) / drag.rect.height) * 100;
        drag.pin.style.setProperty('--x', Math.max(-2, Math.min(86, x)).toFixed(2) + '%');
        drag.pin.style.setProperty('--y', Math.max(-2, Math.min(78, y)).toFixed(2) + '%');
      });
      const end = () => {
        if (!drag) return;
        const { pin, moved } = drag;
        pin.classList.remove('is-drag');
        if (moved) {
          snapPin(pin);
          clack(pin);
          pin.__iklMoved = true;
          const h = pin.getAttribute('data-ikl-pin');
          const list = getBoard();
          const it = list.find((i) => keyOf(i) === h);
          if (it) {
            it.x = parseFloat(pin.style.getPropertyValue('--x'));
            it.y = parseFloat(pin.style.getPropertyValue('--y'));
            it.pl = 1;
            store.set(BOARD_KEY, [it, ...list.filter((i) => keyOf(i) !== h)]);
          }
        }
        drag = null;
      };
      canvas.addEventListener('pointerup', end);
      canvas.addEventListener('pointercancel', end);

      // Phones: hold a pin for a moment until it lifts, then move it with the finger, like app icons on
      // an iPhone. A quick swipe still scrolls the board, a tap still opens the product.
      let hold = null;
      canvas.addEventListener('touchstart', (e) => {
        if (free() || e.touches.length > 1) return;
        const pin = e.target.closest('[data-ikl-pin]');
        if (!pin || e.target.closest('[data-ikl-remove]')) return;
        const t = e.touches[0];
        const pr = pin.getBoundingClientRect();
        hold = { pin, sx: t.clientX, sy: t.clientY, dx: t.clientX - pr.left, dy: t.clientY - pr.top, on: false, moved: false };
        hold.timer = window.setTimeout(() => {
          if (!hold) return;
          hold.on = true;
          pin.classList.add('is-drag');
          d.classList.add('is-holding');
          canvas.querySelectorAll('[data-ikl-pin]').forEach((p) => p.style.setProperty('--z', p === pin ? 999 : Math.min(998, +p.style.getPropertyValue('--z') || 1)));
          if (navigator.vibrate) navigator.vibrate(8);
        }, 320);
      }, { passive: true });
      canvas.addEventListener('touchmove', (e) => {
        if (!hold) return;
        const t = e.touches[0];
        if (!hold.on) {
          // moved before the pin lifted: this is scrolling
          if (Math.abs(t.clientX - hold.sx) + Math.abs(t.clientY - hold.sy) > 8) {
            window.clearTimeout(hold.timer);
            hold = null;
          }
          return;
        }
        e.preventDefault();
        const rect = canvas.getBoundingClientRect();
        const unit = rect.width / 100;
        hold.pin.style.setProperty('--mx', Math.max(0, Math.min(100 - PHONE_PIN, (t.clientX - rect.left - hold.dx) / unit)).toFixed(2));
        hold.pin.style.setProperty('--my', Math.max(0, (t.clientY - rect.top - hold.dy) / unit).toFixed(2));
        hold.moved = true;
        const bin = d.querySelector('[data-ikl-trash]');
        if (bin) {
          const br = bin.getBoundingClientRect();
          hold.hot = t.clientX > br.left - 24 && t.clientX < br.right + 24 && t.clientY > br.top - 40;
          bin.classList.toggle('is-hot', hold.hot);
          hold.pin.classList.toggle('is-trashing', hold.hot);
        }
      }, { passive: false });
      const drop = () => {
        if (!hold) return;
        window.clearTimeout(hold.timer);
        const { pin, on, moved, hot } = hold;
        hold = null;
        d.classList.remove('is-holding');
        const bin = d.querySelector('[data-ikl-trash]');
        if (bin) bin.classList.remove('is-hot');
        if (!on) return;
        pin.classList.remove('is-drag', 'is-trashing');
        if (hot) {
          removeFromBoard(pin.getAttribute('data-ikl-pin'));
          draw();
          return;
        }
        // the tap that ends a hold must not open the product
        pin.__iklMoved = true;
        window.setTimeout(() => (pin.__iklMoved = false), 450);
        if (!moved) return;
        hintDone();
        snapPin(pin);
        clack(pin);
        // every pin keeps the place it has now (pins without a saved place would otherwise move up when
        // the moved one goes to the front of the list)
        const at = {};
        canvas.querySelectorAll('[data-ikl-pin]').forEach((p) => {
          at[p.getAttribute('data-ikl-pin')] = { mx: parseFloat(p.style.getPropertyValue('--mx')), my: parseFloat(p.style.getPropertyValue('--my')) };
        });
        const h = pin.getAttribute('data-ikl-pin');
        const list = getBoard().map((i) => (at[keyOf(i)] ? { ...i, ...at[keyOf(i)] } : i));
        const it = list.find((i) => keyOf(i) === h);
        if (it) store.set(BOARD_KEY, [it, ...list.filter((i) => keyOf(i) !== h)]);
        fitHeight();
      };
      canvas.addEventListener('touchend', drop);
      canvas.addEventListener('touchcancel', drop);
      // A drag must not open the product
      canvas.addEventListener(
        'click',
        (e) => {
          const pin = e.target.closest('[data-ikl-pin]');
          if (pin && pin.__iklMoved) {
            e.preventDefault();
            pin.__iklMoved = false;
          }
        },
        true
      );
    }

    d.addEventListener('click', async (e) => {
      const rm = e.target.closest('[data-ikl-remove]');
      if (rm) {
        removeFromBoard(rm.getAttribute('data-ikl-remove'));
        draw();
        return;
      }
      if (e.target.closest('[data-ikl-shuffle]')) {
        if (free()) {
          scatterNext = true;
          scatterAll = true;
          draw();
          return;
        }
        const order = getBoard().map((i, n) => [Math.random(), n]).sort((a, b) => a[0] - b[0]).map((e) => e[1]);
        saveBoard(getBoard().map((i, n) => ({ ...i, ...spot(order.indexOf(n)), ...phoneSpot(order.indexOf(n), true) })));
        draw();
        return;
      }
      if (e.target.closest('[data-ikl-clear]')) {
        if (window.confirm(T('lab.confirm_clear'))) {
          saveBoard([]);
          draw();
        }
        return;
      }
      const share = e.target.closest('[data-ikl-share]');
      if (share) {
        const list = getBoard();
        if (!list.length) return;
        const url = new URL(location.origin + base);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        url.searchParams.set('ikn-board', list.map(keyOf).join(','));
        const text = T('lab.share_title');
        try {
          if (navigator.share) {
            await navigator.share({ title: text, url: url.toString() });
          } else {
            await navigator.clipboard.writeText(url.toString());
            share.textContent = T('lab.link_copied');
          }
        } catch (err) {
          share.textContent = T('lab.link_copied');
          try {
            await navigator.clipboard.writeText(url.toString());
          } catch (err2) {
            window.prompt(T('lab.copy_link'), url.toString());
          }
        }
        return;
      }
      if (e.target.closest('[data-ikl-adopt]')) {
        const mine = getBoard();
        const known = new Set(mine.map(keyOf));
        saveBoard([...items.filter((i) => !known.has(keyOf(i))), ...mine]);
        d.close();
        openBoard();
        return;
      }
      const buy = e.target.closest('[data-ikl-buyall]');
      if (buy) addAllToCart(own ? getBoard() : items, buy);
    });
    window.addEventListener('resize', draw, { passive: true });
    d.addEventListener('close', () => window.removeEventListener('resize', draw));
  };

  // A shared board link: ?ikn-board=handle1,handle2~variant id
  const sharedParam = new URL(location.href).searchParams.get('ikn-board');
  if (sharedParam) {
    const keys = [...new Set(sharedParam.split(',').map((k) => k.trim()).filter(Boolean))].slice(0, 24);
    const clean = new URL(location.href);
    clean.searchParams.delete('ikn-board');
    history.replaceState(history.state, '', clean.toString());
    Promise.all(keys.map((k) => fetchProduct(splitKey(k).h))).then((list) => {
      const items = list.map((p, n) => (p ? itemFrom(p, n, splitKey(keys[n]).vid) : null)).filter(Boolean);
      if (items.length) openBoard(items);
    });
  }

  // Shared with ik-tools.js
  window.__ikl = { root, template, T, base, num, esc, abs, sized, store, icon, openSheet, sheetHead, onBoard, pinKey };
})();
